import FacebookIcon from '@material-ui/icons/Facebook'
import InstagramIcon from '@material-ui/icons/Instagram'
import TwitterIcon from '@material-ui/icons/Twitter'
import HelpIcon from '@material-ui/icons/Help'

import useLogEvent from 'amplitude/useLogEvent'

import useFreeTrialExperiment from 'experiments/useFreeTrialExperiment'

const useSocialNetworks = (withIcons = true) => {
  const { hasFreeTrial } = useFreeTrialExperiment()

  const helpPath = hasFreeTrial
    ? process.env.REACT_APP_HELPCENTER_HOME_V2
    : process.env.REACT_APP_HELPCENTER_HOME
  const feedbackPath = process.env.REACT_APP_FEEDBACK_FORM_LINK
  const twitterPath = 'twitter.com/SuperSummary'
  const instagramPath = 'www.instagram.com/supersummary/'
  const facebookPath = 'www.facebook.com/supersummary/'

  const logEvent = useLogEvent()

  return [
    {
      id: 'help',
      name: 'Help',
      path: helpPath,
      Icon: withIcons && HelpIcon,
      customFieldValues: {
        resourceType: 'footer-connect',
      },
      onClick: () => logEvent('View Secondary Page - Support'),
    },
    {
      id: 'feedback',
      name: 'Feedback',
      path: feedbackPath,
      customFieldValues: {
        resourceType: 'footer-connect',
      },
    },
    {
      id: 'twitter',
      name: 'Twitter',
      path: twitterPath,
      Icon: withIcons && TwitterIcon,
      customFieldValues: {
        resourceType: 'footer-connect',
      },
    },
    {
      id: 'facebook',
      name: 'Facebook',
      path: facebookPath,
      Icon: withIcons && FacebookIcon,
      customFieldValues: {
        resourceType: 'footer-connect',
      },
    },
    {
      id: 'instagram',
      name: 'Instagram',
      path: instagramPath,
      Icon: withIcons && InstagramIcon,
      customFieldValues: {
        resourceType: 'footer-connect',
      },
    },
  ]
}

export default useSocialNetworks
